<template>
    <div class="row">
        <div class="col-lg-12">
            <object style="height: 1100px; width: 100%" data="https://www.weather.go.kr/w/ocean/forecast/mid-term-forecast.do" type="text/html" name="weatherko" frameborder="0" scrolling="yes"></object>
        </div>
    </div>
</template>
<script>
export default {
    name: "weather",
    components: {
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {

    }
};
</script>
<style>
</style>
